import React, { useCallback } from 'react';

import { useField } from 'formik';
import UploadField from '..';

const UploadFieldMemo = React.memo(UploadField);

const UploadFieldCFormik = (props) => {
	const { name } = props;
	const [field, meta, helpers] = useField(name);
	const { setValue, setTouched } = helpers;

	const handleChange = useCallback(
		(files) => {
			setValue(files);
			setTimeout(() => {
				setTouched(true);
			}, 0);
		},
		[setValue, setTouched],
	);

	if (!name) return 'For UploadField connected to Formik name is required!';

	return (
		<UploadFieldMemo
			value={field.value}
			error={(meta.touched || meta.initialTouched) && meta.error}
			onChange={handleChange}
			{...props}
		/>
	);
};

UploadFieldCFormik.propTypes = {
	...UploadField.propTypes,
};

export default UploadFieldCFormik;
